import React from "react";
import styles from "./ScheduledRideInfo.module.scss";
import { formatScheduledRideDateTime } from "../scheduledRideUtils";
import CalendarIcon from "./icons/CalendarIcon";
import ClockIcon from "./icons/ClockIcon";

function ScheduledRideInfo({ scheduledInfo }) {
  if (!scheduledInfo?.scheduled_time) return null;

  const { date, time } = formatScheduledRideDateTime(scheduledInfo.scheduled_time);

  return (
    <div className={styles.scheduledInfo}>
      <div className={styles.dateTimeRow}>
        <div style={{flex: 2}} className={styles.pill}>
          <CalendarIcon className={styles.pillIcon} />
          <span className={styles.pillText}>{date}</span>
        </div>
        <div style={{flex: 1}} className={styles.pill}>
          <ClockIcon className={styles.pillIcon} />
          <span className={styles.pillText}>{time}</span>
        </div>
      </div>

      <p className={styles.timezoneNote}>Date and time are set in CET, like time in Belgrade, Serbia</p>

      <div className={styles.metaRow}>
        <div className={styles.metaItem}>
          <span className={styles.metaLabel}>Passengers</span>
          <span className={styles.metaValue}>{scheduledInfo.num_of_passengers ?? 0}</span>
        </div>
        <div className={styles.metaItem}>
          <span className={styles.metaLabel}>Baggage</span>
          <span className={styles.metaValue}>{scheduledInfo.num_of_baggage ?? 0}</span>
        </div>
      </div>

      {scheduledInfo.additional_comment && (
        <div className={styles.comment}>
          <span className={styles.commentLabel}>Additional comment</span>
          <p className={styles.commentText}>{scheduledInfo.additional_comment}</p>
        </div>
      )}
    </div>
  );
}

export default ScheduledRideInfo;
